import { MD3LightTheme } from "react-native-paper";

export const colors = {
    ...MD3LightTheme.colors,
    textDark: "#3b3b3b",
    textLight: "#eeeeee",

    // Brand colors
    primary: "#201c35",
    secondary: "#1A428A",
    tertiary: "#345F9C",

    // Grayscale variants. Dark to bright
    black: "#000000",
    grey50: "#f7f7f7",
    grey100: "#E8E8E8",
    grey250: "#CCC",
    grey500: "#909090",
    grey800: "#434343",
    lightGrey: "#C4C4C4",
    white: "#FFFFFF",

    // message warning levels: error -> success
    error: "#c00f4f",
    errorl1: "#de3163",
    warning: "#F47418",
    info: "#345F9C",
    success: "#76B72A",
    toastDefault: "#eeeeee",

    // UI details
    semiTransparentBlack: "rgba(0,0,0,0.3)",
    semiTransparentBackground: "rgba(0,0,0,0.6)",
    semiTransparentError: "rgba(192,15,79,0.5)",
    transparentLine: "rgba(255,255,255,0.4)",
};
